/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetStageDefinitionDto
 */
export interface GetStageDefinitionDto {
    /**
     * 
     * @type {string}
     * @memberof GetStageDefinitionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetStageDefinitionDto
     */
    stageType: GetStageDefinitionDtoStageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof GetStageDefinitionDto
     */
    order: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetStageDefinitionDto
     */
    active: boolean;
}


/**
 * @export
 */
export const GetStageDefinitionDtoStageTypeEnum = {
    CampaignCompletion: 'CampaignCompletion',
    Contracts: 'Contracts',
    IntercompanyOrders: 'IntercompanyOrders',
    CampaignSettlement: 'CampaignSettlement'
} as const;
export type GetStageDefinitionDtoStageTypeEnum = typeof GetStageDefinitionDtoStageTypeEnum[keyof typeof GetStageDefinitionDtoStageTypeEnum];


/**
 * Check if a given object implements the GetStageDefinitionDto interface.
 */
export function instanceOfGetStageDefinitionDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "stageType" in value;
    isInstance = isInstance && "order" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function GetStageDefinitionDtoFromJSON(json: any): GetStageDefinitionDto {
    return GetStageDefinitionDtoFromJSONTyped(json, false);
}

export function GetStageDefinitionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStageDefinitionDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'stageType': json['stageType'],
        'order': json['order'],
        'active': json['active'],
    };
}

export function GetStageDefinitionDtoToJSON(value?: GetStageDefinitionDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'stageType': value.stageType,
        'order': value.order,
        'active': value.active,
    };
}

